/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateShareExportDataDto } from './UpdateShareExportDataDto';
import {
    UpdateShareExportDataDtoFromJSON,
    UpdateShareExportDataDtoFromJSONTyped,
    UpdateShareExportDataDtoToJSON,
    UpdateShareExportDataDtoToJSONTyped,
} from './UpdateShareExportDataDto';

/**
 * 
 * @export
 * @interface UpdateShareExportResponseDto
 */
export interface UpdateShareExportResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateShareExportResponseDto
     */
    message: string;
    /**
     * 
     * @type {UpdateShareExportDataDto}
     * @memberof UpdateShareExportResponseDto
     */
    data: UpdateShareExportDataDto;
}

/**
 * Check if a given object implements the UpdateShareExportResponseDto interface.
 */
export function instanceOfUpdateShareExportResponseDto(value: object): value is UpdateShareExportResponseDto {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateShareExportResponseDtoFromJSON(json: any): UpdateShareExportResponseDto {
    return UpdateShareExportResponseDtoFromJSONTyped(json, false);
}

export function UpdateShareExportResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateShareExportResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'data': UpdateShareExportDataDtoFromJSON(json['data']),
    };
}

export function UpdateShareExportResponseDtoToJSON(json: any): UpdateShareExportResponseDto {
    return UpdateShareExportResponseDtoToJSONTyped(json, false);
}

export function UpdateShareExportResponseDtoToJSONTyped(value?: UpdateShareExportResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'data': UpdateShareExportDataDtoToJSON(value['data']),
    };
}

